import Const from 'constants';
import Action from 'actions';

const NhlTeamStackingAction = {
    useStacking(use) {
        return {
            type: Const.NHL_TEAM_STACKING_IS_USED,
            use,
        };
    },

    setTeams(teams) {
        return {
            type: Const.NHL_TEAM_STACKING_SET_TEAMS,
            teams,
        };
    },

    setTeamsAreChosenRandomly(chooseTeamsRandomly) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_TEAM_STACKING_SET_TEAMS_ARE_CHOSEN_RANDOMLY,
                chooseTeamsRandomly,
            });

            dispatch(this.saveNhlTeamStackingToStorage());
        };
    },

    setTeamsAreForcedToStacking(forceTeamsToStacking) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_TEAM_STACKING_SET_TEAMS_ARE_FORCED_TO_STACKING,
                forceTeamsToStacking,
            });

            dispatch(this.saveNhlTeamStackingToStorage());
        };
    },

    setStackTeamsIsCheckedForStackNumber(checked, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_TEAM_STACKING_SET_STACK_TEAMS_IS_CHECKED,
                checked,
                stackNumber,
            });

            dispatch(this.saveNhlTeamStackingToStorage());
        };
    },

    setStackTeamsExposureForStackNumber(exposure, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_TEAM_STACKING_SET_STACK_TEAMS_EXPOSURE,
                exposure,
                stackNumber,
            });

            dispatch(this.saveNhlTeamStackingToStorage());
        };
    },

    setLineGroupsForStackNumber(lineGroups, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_TEAM_STACKING_SET_TEAM_LINE_GROUP_IS_CHECKED,
                lineGroups,
                stackNumber,
            });

            dispatch(this.saveNhlTeamStackingToStorage());
        };
    },

    setTeamLineGroupsForStackNumber(lineGroups, team, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_TEAM_STACKING_SET_TEAM_LINE_GROUPS,
                lineGroups,
                team,
                stackNumber,
            });

            dispatch(this.saveNhlTeamStackingToStorage());
        };
    },

    setPPLinesForStackNumber(ppLines, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_TEAM_STACKING_SET_TEAM_PP_LINE_IS_CHECKED,
                ppLines,
                stackNumber,
            });

            dispatch(this.saveNhlTeamStackingToStorage());
        };
    },

    setTeamPPLinesForStackNumber(ppLines, team, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_TEAM_STACKING_SET_TEAM_PP_LINES,
                ppLines,
                team,
                stackNumber,
            });

            dispatch(this.saveNhlTeamStackingToStorage());
        };
    },

    setTeamIsCheckedForStackNumber(team, checked, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_TEAM_STACKING_SET_TEAM_IS_CHECKED,
                team,
                checked,
                stackNumber,
            });

            dispatch(this.saveNhlTeamStackingToStorage());
        };
    },

    setTeamDefensemanIsIncluded(team, checked, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_TEAM_STACKING_SET_TEAM_DEFENSEMAN_IS_INCLUDED,
                team,
                checked,
                stackNumber,
            });

            dispatch(this.saveNhlTeamStackingToStorage());
        };
    },

    setTeamExposureForStackNumber(team, exposure, stackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_TEAM_STACKING_SET_TEAM_EXPOSURE,
                team,
                exposure,
                stackNumber,
            });

            dispatch(this.saveNhlTeamStackingToStorage());
        };
    },

    setCombinationIsChecked(comboKey, checked) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_TEAM_STACKING_SET_COMBO_IS_CHECKED,
                comboKey,
                checked,
            });

            dispatch(this.saveNhlTeamStackingToStorage());
        };
    },

    setCombinationExposure(comboKey, exposure) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_TEAM_STACKING_SET_COMBO_EXPOSURE,
                comboKey,
                exposure,
            });

            dispatch(this.saveNhlTeamStackingToStorage());
        };
    },

    setNhlTeamStackingSettingsFromStorage(data) {
        return {
            type: Const.NHL_TEAM_STACKING_SET_DATA_FROM_STORAGE,
            data,
        };
    },

    mirrorStack(sourceStackNumber, destinationStackNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.NHL_TEAM_STACKING_MIRROR_STACK,
                sourceStackNumber,
                destinationStackNumber,
            });

            dispatch(this.saveNhlTeamStackingToStorage());
        };
    },

    saveNhlTeamStackingToStorage() {
        return (dispatch) => {
            dispatch(
                Action.saveDataToStorage('nhlTeamStackingSettings', function (state) {
                    const {nhlTeamStacking} = state;

                    return {...nhlTeamStacking.data};
                }),
            );
        };
    },
};

export default NhlTeamStackingAction;
